module.exports = __webpack_public_path__ + "joy-static/media/CameraTargetIndicator.e1da7928.svg";